import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import ProtectedRoute from "@/components/app/ProtectedRoute";
import AppShell from "@/components/app/AppShell";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Cockpit from "@/pages/Cockpit";
import Capital from "@/pages/Capital";
import PeopleOrg from "@/pages/PeopleOrg";
import Documents from "@/pages/Documents";
import BrandSystem from "@/pages/BrandSystem";
import MissionControl from "@/pages/MissionControl";
import VentureCommandCenter from "@/pages/VentureCommandCenter";
import WeeklyDigest from "@/pages/WeeklyDigest";
import AdminConsole from "@/pages/AdminConsole";
import "@/App.css";

function App() {
  return (
    <div className="dark App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/auth/google" element={<AuthCallback />} />
            <Route element={<ProtectedRoute />}>
              <Route element={<AppShell />}>
                <Route path="/" element={<Cockpit />} />
                <Route path="/mission-control" element={<MissionControl />} />
                <Route path="/mission-control/venture/:id" element={<VentureCommandCenter />} />
                <Route path="/mission-control/digest" element={<WeeklyDigest />} />
                <Route path="/admin" element={<AdminConsole />} />
                <Route path="/capital" element={<Capital />} />
                <Route path="/people" element={<PeopleOrg />} />
                <Route path="/documents" element={<Documents />} />
                <Route path="/documents/brand-system" element={<BrandSystem />} />
              </Route>
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-right" theme="dark" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
